import { render, staticRenderFns } from "./IconSprite.vue?vue&type=template&id=4f7d20ee&"
import script from "./IconSprite.vue?vue&type=script&lang=ts&"
export * from "./IconSprite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports